import * as React from "react";

function SvgThumbsUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 21 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M15.29 8.48C15.11 8 19.93 3.64 17.12.09c-.65-.82-2.89 4-6.05 6.14-1.75 1.2-5.82 3.77-5.82 5.16v9.12c0 1.7 6.45 3.49 11.35 3.49 1.8 0 4.4-11.43 4.4-13.25S15.46 9 15.29 8.48zm-11.35.13A3.91 3.91 0 000 12.77v6.47a3.78 3.78 0 003.94 4c.86 0-1.32-.77-1.32-3v-8.5c0-2.34 2.18-3.13 1.32-3.13z" />
    </svg>
  );
}

const MemoSvgThumbsUp = React.memo(SvgThumbsUp);
export default MemoSvgThumbsUp;
